import { Link } from "react-router-dom";

const categoryLinks = [
  { name: "热血冒险", path: "/category/rexue-maoxian" },
  { name: "恋爱言情", path: "/category/lianai-yanqing" },
  { name: "悬疑推理", path: "/category/xuanyi-tuili" },
  { name: "玄幻修仙", path: "/category/xuanhuan-xiuxian" },
  { name: "科幻机甲", path: "/category/kehuan-jijia" },
  { name: "搞笑日常", path: "/category/gaoxiao-richang" },
  { name: "运动竞技", path: "/category/yundong-jingji" },
  { name: "奇幻魔法", path: "/category/qihuan-mofa" },
];

const helpLinks = [
  { name: "首页", path: "/" },
  { name: "漫画分类大全", path: "/category" },
  { name: "漫画排行榜", path: "/category" },
  { name: "关于我们", path: "/about" },
];

export default function Footer() {
  return (
    <footer className="mt-16 bg-background-100 text-foreground-800">
      <div className="mx-auto grid w-full max-w-7xl gap-10 px-4 py-12 sm:grid-cols-2 md:px-6 lg:grid-cols-4">
        <div className="sm:col-span-2 lg:col-span-1">
          <div className="flex items-center gap-2">
            <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500 text-background-50">
              <i className="ri-book-2-line text-xl" />
            </span>
            <span className="font-heading text-xl text-primary-600">漫途导航</span>
          </div>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600">
            汇集漫画分类大全与漫画类型大全，按题材分类整理漫画推荐大全，并附漫画排行榜大全与漫画人气排行，帮你快速找到想看的漫画。
          </p>
          <div className="mt-4 flex items-center gap-3 text-foreground-600">
            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-background-200">
              <i className="ri-wechat-line" />
            </span>
            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-background-200">
              <i className="ri-weibo-line" />
            </span>
            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-background-200">
              <i className="ri-bilibili-line" />
            </span>
          </div>
        </div>

        <nav aria-label="热门分类">
          <h4 className="font-heading text-base text-foreground-900">热门分类</h4>
          <ul className="mt-4 grid grid-cols-2 gap-2.5 text-sm">
            {categoryLinks.map((c) => (
              <li key={c.name}>
                <Link to={c.path} className="text-foreground-600 transition-colors hover:text-primary-600">
                  {c.name}
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        <nav aria-label="快速链接">
          <h4 className="font-heading text-base text-foreground-900">快速导航</h4>
          <ul className="mt-4 flex flex-col gap-2.5 text-sm">
            {helpLinks.map((h) => (
              <li key={h.name}>
                <Link to={h.path} className="text-foreground-600 transition-colors hover:text-primary-600">
                  {h.name}
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        <div>
          <h4 className="font-heading text-base text-foreground-900">联系我们</h4>
          <ul className="mt-4 flex flex-col gap-2.5 text-sm text-foreground-600">
            <li className="flex items-center gap-2">
              <i className="ri-mail-line text-primary-500" />
              <span>hello@mantudh.com</span>
            </li>
            <li className="flex items-center gap-2">
              <i className="ri-phone-line text-primary-500" />
              <span>400-888-9999</span>
            </li>
            <li className="flex items-center gap-2">
              <i className="ri-map-pin-2-line text-primary-500" />
              <span>中国·杭州 西湖创意园区</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-background-200/70">
        <div className="mx-auto flex w-full max-w-7xl flex-col items-center justify-between gap-2 px-4 py-5 text-xs text-foreground-500 sm:flex-row md:px-6">
          <p>© {new Date().getFullYear()} 漫途导航 · 漫画分类大全 版权所有</p>
          <p className="flex items-center gap-2">
            <span>漫画分类大全导航</span>
            <span>·</span>
            <span>浙ICP备2026XXXXXX号</span>
          </p>
        </div>
      </div>
    </footer>
  );
}